import { SvgIconComponent } from '@ngneat/svg-icon';
import { Component, Input, inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';

import { Customer } from 'src/app/domain/Customer';

import { GlobalService } from '../../../services/global.service';
import { iconCloseIcon } from '@svg/icon-close';
import { registerSvgIcons } from '@shared/utils/svg-icons';


@Component({
  selector: 'app-glovo-bags-vendor-modal',
  templateUrl: './glovo-bags-vendor-modal.component.html',
  styleUrls: ['./glovo-bags-vendor-modal.component.scss'],
  standalone: true,
  imports: [
    SvgIconComponent,
    CommonModule,
    TranslateModule,
    ],
})
export class GlovoBagsVendorModalComponent implements OnInit {
  private readonly activeModal = inject(NgbActiveModal);
  private readonly globalService = inject(GlobalService);

  @Input() customer: Customer;
  shopName: string = '';
  logoMobile: string;

  constructor() {
    registerSvgIcons(iconCloseIcon);
  }


  ngOnInit(): void {
    const shopConfiguration = this.globalService.getShoptConfiguration();
    this.logoMobile = shopConfiguration?.logoColorMobile?.url;

    this.globalService.params$
      .pipe(
        map(p => p?.shopConfiguration?.name ?? ''),
        distinctUntilChanged()
      )
      .subscribe(name => {
        this.shopName = name;
      });
  }

  close() {
    this.activeModal.close();
  }
}
